/*
 * 图片上传基础组件，包括多图片与单图片上传两种形式
 * @Author: zwt.daffy
 * @Date: 2019-07-10 14:47:41
 * @Last Modified by: zwt.daffy
 * @Last Modified time: 2020-02-21 23:17:27
 * 传的参数有：action-上传地址,mutiple-是否多张，value-原值，maxsize-图片最大大小，uploadType-图片类型
 * 触发的事件： success-成功回调，error-失败回调
 *
 * 注意：list文件时，传入的list必须是一个独立的组，父组件不要再对这个组做更新
 *
 */
<template>
  <section class="upload-box">
    <el-upload
      class="uploader"
      :class="{'uploader-list':multiple,'full': fileCount >= limit}"
      :action="action"
      :data="{
        needAuth: 'noauth'
      }"
      :multiple="multiple"
      :headers="headers"
      :accept="acceptTypeList.join(',')"
      :show-file-list="multiple"
      :file-list="list"
      :limit="limit"
      list-type="picture-card"
      :before-upload="handleBeforeUpload"
      :on-success="handleUploadSuccess"
      :on-error="hanldeUploadError"
      :on-exceed="handleUploadExceed"
      :on-remove="handleRemove"
      :on-progress="handleUploading"
    >
      <template v-if="!multiple">
        <div slot="trigger">
          <div v-if="uploading">
            <el-progress :width="100" :height="100" type="circle" :percentage="uploadNum"></el-progress>
          </div>
          <template v-else>
            <img :width="width" :height="height" v-if="value" :src="value" />
            <div class="upload-btn" v-else>
              <i class="el-icon-plus"></i>
              <div class="el-plus-tips">上传照片</div>
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div v-if="fileCount < limit" class="upload-btn" slot="trigger">
          <i slot="trigger" class="el-icon-plus list"></i>
          <div class="el-plus-tips">上传照片</div>
        </div>
      </template>
    </el-upload>
  </section>
</template>
<script>
import storage from '@/utils/storage'
const config = require('../../../../config')
const baseUrl = config[process.env.NODE_ENV === 'production' ? 'build' : 'dev'].baseURL
export default {
  name: 'upload',
  props: {
    value: {
      type: String,
      default: ''
    },
    params: {
      type: Object
    },
    multiple: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    limit: {
      type: Number,
      default: 10
    },
    maxSize: {
      type: Number,
      default: 1024
    },
    uploadType: {
      type: Array,
      default: () => {
        return ['png', 'jpg', 'jpeg']
      }
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    }
  },
  computed: {
    fileCount () {
      return this.count
    },
    acceptTypeList () {
      return this.uploadType.map(item => 'image/' + item)
    }
  },
  data () {
    return {
      count: 0,
      uploading: false,
      uploadNum: 0,
      // action: baseUrl + '/ipark/portal/images/upload/noToken',
      action: baseUrl + (this.utils.isDevelop() ? '' : '/ipark') + '/portal/images/upload/noToken',
      headers: {
        loginToken: storage.get('loginToken')
      }
    }
  },
  created () {
    this.count = this.list.length
  },
  methods: {
    handleBeforeUpload (file) {
      console.log('上传before')
      if (file.size > this.maxSize * 1024 || file.size <= 0) {
        const msg =
          file.size <= 0
            ? '上传图片大小不能小于0KB'
            : `上传图片大小不超过${
              this.maxSize >= 1024
                ? Math.floor(this.maxSize / 1024) + 'M'
                : this.maxSize + 'KB'
            }`
        this.$message.error(msg)
        return false
      } else if (this.acceptTypeList.indexOf(file.type) === -1) {
        this.$message.error(`上传图片类型必须为${this.uploadType.join(',')}`)
        return false
      }
      this.uploading = true
    },
    handleRemove (file, fileList) {
      this.count--
      console.log(fileList)
      const list = fileList.map(item => {
        const file = {
          name: item.name,
          url: item.response ? item.response.body.url : item.url
        }
        return file
      })
      this.$emit('change', list)
    },
    handleUploadSuccess (res, file, fileList) {
      this.uploading = false
      let body = res.body
      if (body && body.url) {
        if (this.multiple) {
          const list = fileList.map(item => {
            console.log(item)
            const file = {
              name: item.name,
              url: item.response ? item.response.body.url : item.url
            }
            return file
          })
          this.count = fileList.length
          this.$emit('change', list)
        } else {
          body.name = body.fileName
          // body.url = body.path
          this.$emit('change', body)
        }
      } else {
        this.$message.error('上传失败')
        this.$emit('error', res)
      }
    },
    hanldeUploadError (err) {
      console.log(err)
      this.$emit('error', err)
      this.$message.error('上传失败')
      this.uploading = false
    },
    handleUploading (event, file) {
      this.uploadNum = Math.floor(event.percent / 1.2)
    },
    handleUploadExceed (file) {
      this.$message(`最多上传${this.limit}张图片`)
    }
  }
}
</script>
<style lang="less">
.upload-box {
  .el-upload {
    height: 100px;
    width: 100px;
    border: none;
    .upload-btn {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      background-color: #fbfbfb;
      cursor: pointer;
      position: relative;
      width: 100px;
      line-height: 25px;
      height: 100px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      img {
        width: 100px;
        height: 100px;
      }
      .el-icon-plus {
        line-height: 32px;
        font-size: 32px;
        color: #8c939d;
        text-align: center;
      }
      .el-plus-tips {
        color: #666;
        font-size: 12px;
      }
    }
  }
  .uploader-list {
    &.full {
      .el-upload--picture-card {
        display: none;
      }
    }
  }
  .el-upload-list--picture-card {
    .el-upload-list__item {
      width: 100px;
      height: 100px;
      transition: none;
    }
    .el-progress .el-progress-circle {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/components/common/ImageUpload.vue